import { Deadline as DeadlineBox } from "../../ds"
import { shortDate } from "../format"

const DAY = 864e5

/** Whole days from today to an ISO date; negative once it has passed. */
export function daysUntil(iso: string, now: Date = new Date()): number | null {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso)
  if (!m) return null
  const due = Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3]))
  const today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate())
  return Math.round((due - today) / DAY)
}

/** The next date to meet (Results-v4 05): the date in serif, the basis, and how long is left. */
export function Deadline({ label, date, basis }: { label?: string; date: string; basis?: string }) {
  const days = daysUntil(date)
  const left =
    days === null ? undefined
      : days > 1 ? `${days} days left`
      : days === 1 ? "1 day left"
      : days === 0 ? "Today"
      : `Passed ${-days} ${days === -1 ? "day" : "days"} ago`
  return <DeadlineBox className="adl" label={label || "Reply by"} date={shortDate(date)} basis={basis || undefined} set={left} />
}
